import type { Expression, FillLayer, LineLayer } from 'mapbox-gl';

export const SOURCE_NETWORK_ROAD_DATA_ID = 'network_road_data' as const;

export const COLOR_BY_RUBRIC = {
    LARGEUR: '#CF68FF',
    LARGEUR_ET_SURFACE: '#F0A202',
    LARGEUR_ET_SURFACE_II: '#D89101',
    LARGEUR_ET_SURFACE_III: '#F3B434',
};

const COLOR: Expression = [
    'case',
    ...Object.entries(COLOR_BY_RUBRIC)
        .map(([rubric, color]) => [['==', ['get', 'rubricCode'], rubric], color])
        .flat(),
    '#000000',
];
const OPACITY: Expression = ['case', ['boolean', ['feature-state', 'hover'], false], 0.5, 1];
const WIDTH: Expression = ['case', ['boolean', ['feature-state', 'hover'], false], 6, 3];

// layer config for display lines road-data
export const LAYER_LINE_NETWORK_ROAD_DATA_ID = 'network_road_data_line' as const;
export const ROAD_DATA_LINESTRING_LAYER: LineLayer = {
    id: LAYER_LINE_NETWORK_ROAD_DATA_ID,
    source: SOURCE_NETWORK_ROAD_DATA_ID,
    type: 'line',
    minzoom: 18,
    paint: {
        'line-color': COLOR,
        'line-opacity': OPACITY,
        'line-width': WIDTH,
    },
} as const;

// layer config for display degradation polygons
export const LAYER_FILL_DEGRADATIONS_ID = 'degradations_fill' as const;
export const DEGRADATIONS_FILL_LAYER: FillLayer = {
    id: LAYER_FILL_DEGRADATIONS_ID,
    type: 'fill',
    minzoom: 18,
    paint: {
        'fill-color': ['get', 'color'] as Expression,
        'fill-opacity': 0.7,
    },
} as const;
